import { FC } from 'react';

import CustomLoading from '../../CustomLoading';

import CanjeModalBody from './components/CanjeModalBody';
import CanjeModalFooter from './components/CanjeModalFooter';
import CanjeModalHeader from './components/CanjeModalHeader';
import { useCanjeModal } from './context/CanjeModalContext';

import '../Modals.scss';

const CanjeModal: FC = () => {
  const { data } = useCanjeModal();

  return (
    <>
      <CanjeModalHeader />
      <CanjeModalBody />
      <CanjeModalFooter />
      {data.isLoading && <CustomLoading />}
    </>
  );
};

export default CanjeModal;
